import { Injectable, InjectionToken } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { ContainerDefinition } from '../../shared/services/container-definition.service';
import { Crop } from '../../shared/services/crop.service';
import { Substrate } from '../../shared/services/substrate.service';
import { ActivatedRoute } from '@angular/router';
import { ReportingOptions } from '../resolvers/reporting-filter-options.resolver';
import { Laboratory } from '../../shared/services/laboratory.service';
import { GrowthStage, GrowthStageService } from '../../shared/services/growth-stage.service';

export const REPORTING_FILTER_OPTIONS = new InjectionToken('Reporting filter options.');

@Injectable()
export class ReportingFilterOptionsService implements ReportingFilterOptions {

  public get crops(): Observable<Crop[]> {
    return this._cropsSubject.asObservable();
  }

  public get flatTypes(): Observable<ContainerDefinition[]> {
    return this._flatTypesSubject.asObservable();
  }

  public get potTypes(): Observable<ContainerDefinition[]> {
    return this._potTypesSubject.asObservable();
  }

  public get substrates(): Observable<Substrate[]> {
    return this._substratesSubject.asObservable();
  }

  public get laboratories(): Observable<Laboratory[]> {
    return this._laboratoriesSubject.asObservable();
  }

  public get growthStages(): Observable<GrowthStage[]> {
    return this._growthStagesSubect.asObservable();
  }

  private _cropsSubject = new ReplaySubject<Crop[]>(1);
  private _flatTypesSubject = new ReplaySubject<ContainerDefinition[]>(1);
  private _potTypesSubject = new ReplaySubject<ContainerDefinition[]>(1);
  private _substratesSubject = new ReplaySubject<Substrate[]>(1);
  private _laboratoriesSubject = new ReplaySubject<Laboratory[]>(1);
  private _growthStagesSubect = new ReplaySubject<GrowthStage[]>(1);

  constructor(route: ActivatedRoute) {
    route
      .data
      .subscribe(d => {
        const options: ReportingOptions = d.filterOptions;
        this._cropsSubject.next(options.crops);
        this._flatTypesSubject.next(options.flatContainers);
        this._potTypesSubject.next(options.potContainers);
        this._substratesSubject.next(options.substrates);
        this._laboratoriesSubject.next(options.laboratories);
        this._growthStagesSubect.next(options.growthStages);
      });
  }
}

export interface ReportingFilterOptions {
  crops: Observable<Crop[]>;
  flatTypes: Observable<ContainerDefinition[]>;
  potTypes: Observable<ContainerDefinition[]>;
  substrates: Observable<Substrate[]>;
  laboratories: Observable<Laboratory[]>;
  growthStages: Observable<GrowthStage[]>;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/services/reporting-filter-options.service.ts